import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';

const developerUrl = `${environment.apiBaseUrl}platform/developers`;

@Injectable({
  providedIn: SharedModule
})
export class DeveloperService {

  constructor(private http: HttpClient) { }

  list(): Observable<Developer.DeveloperModel[]> {
    return this.http.get<Developer.DeveloperModel[]>(`${developerUrl}`);
  }
  developerList(id: string): Observable<Developer.DeveloperModel[]> {
    return this.http.get<Developer.DeveloperModel[]>(`${environment.apiBaseUrl}platform/teams/${id}/developers`);
  }

  get(id: string): Observable<Developer.DeveloperModel> {
    return this.http.get<Developer.DeveloperModel>(`${developerUrl}/${id}`);
  }

  create(developer: any): Observable<Developer.DeveloperModel> {

    return this.http.post<Developer.DeveloperModel>(`${developerUrl}`, developer);
  }

  update(developer: any): Observable<Developer.DeveloperModel> {
    return this.http.put<Developer.DeveloperModel>(`${developerUrl}/${developer.get('id')}`, developer);
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${developerUrl}/${id}`);
  }

  fields(): Observable<Developer.FieldsModel> {
    return this.http.get<Developer.FieldsModel>(`${developerUrl}/fields`);
  }

  scorecardList(): Observable<Base.KeyLabelModel[]> {
    return this.http.get<Base.KeyLabelModel[]>(`${developerUrl}/scorecards`);
  }

  developersExportList(data: {
    companyRole: string;
    teams: Developer.TeamModel[];
    surname: string;
    name: string;
    userName: string;
    status: boolean;
  }[]): Observable<HttpResponse<Blob>> {
    return this.http.post<Blob>(
      `${environment.apiBaseUrl}platform/export/profiles`,
      data,
      {
        responseType: 'blob' as 'json',
        observe: 'response'
      }
    );
  }

}
